import axios from './request'
import qs from 'qs'
import { setToken,setRefreshToken} from "@/utils/common";

function handleUrl(baseUrl = 'BASE_URL' ,url) {
    baseUrl = process.env[`VUE_APP_${baseUrl}`]
    return url = baseUrl + url
}   

function request(method, url, data,baseUrl) {
    let type = method === 'get' ? 'params' : 'data';
    let obj = {
        url:handleUrl(baseUrl,url),
        method:method,
    }
    obj[type] = data;
    return axios(obj)
}

export default request
